import { useEffect, useState } from "react";
import { Plus, Trash2, Zap, Copy } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function SnippetsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ shortcut: "", content: "" });

  const load = async () => { const { data } = await api.get("/snippets"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.shortcut || !form.content) return;
    const { data } = await api.post("/snippets", form);
    setItems([data, ...items]);
    setForm({ shortcut: "", content: "" });
    toast.success("Snippet saved");
  };
  const remove = async (id) => { await api.delete(`/snippets/${id}`); setItems(items.filter((i) => i.id !== id)); };
  const copy = async (t) => { await navigator.clipboard.writeText(t); toast.success("Copied"); };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Snippets</h1>
      <p className="text-sm text-brand-muted mt-1">Save phrases & signatures you reuse all the time.</p>

      <form onSubmit={add} className="mt-6 bg-white rounded-2xl border border-brand-borderc p-5 grid md:grid-cols-5 gap-3">
        <input data-testid="snippet-shortcut-input" required value={form.shortcut} onChange={(e) => setForm({ ...form, shortcut: e.target.value })} placeholder="/sig" className="md:col-span-1 px-3 py-2.5 rounded-xl border border-brand-borderc text-sm focus:border-brand-purple outline-none" />
        <input data-testid="snippet-content-input" required value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} placeholder="Best regards, Praveen — DraftVoice AI" className="md:col-span-3 px-3 py-2.5 rounded-xl border border-brand-borderc text-sm focus:border-brand-purple outline-none" />
        <button data-testid="snippet-add-btn" className="btn-primary-gradient rounded-full font-semibold inline-flex items-center justify-center gap-1"><Plus className="w-4 h-4" />Save</button>
      </form>

      {items.length === 0 ? (
        <div className="mt-10 text-center py-12 bg-white rounded-3xl border border-brand-borderc">
          <Zap className="w-10 h-10 mx-auto text-brand-purple" />
          <p className="mt-3 text-brand-muted">No snippets yet. Save your first one above.</p>
        </div>
      ) : (
        <div className="mt-6 space-y-2">
          {items.map((i) => (
            <div key={i.id} className="bg-white rounded-xl border border-brand-borderc px-4 py-3 flex items-center justify-between gap-3">
              <div className="flex-1 min-w-0">
                <span className="font-mono text-xs px-2 py-0.5 bg-brand-surface rounded text-brand-purple font-semibold">{i.shortcut}</span>
                <span className="ml-3 text-sm text-brand-text">{i.content}</span>
              </div>
              <div className="flex gap-1">
                <button onClick={() => copy(i.content)} className="p-1.5 text-brand-muted hover:bg-brand-surface rounded-lg"><Copy className="w-4 h-4" /></button>
                <button onClick={() => remove(i.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
